import * as React from "react";
import QuestionLabel from "./QuestionLabel";
import QuestionError from "./QuestionError";
import { SurveyQuestion } from "../../../types";
import getControlProps from "../helpers/getControlProps";

interface LanguageQuestionProps {
  onChange: any;
  question: SurveyQuestion;
  answer: any;
  error: any;
}

class LanguageQuestion extends React.Component<LanguageQuestionProps, {}> {
  onChange = (e: React.FormEvent<HTMLSelectElement>) => {
    this.props.onChange(this.props.question, e.currentTarget.value);
  };

  render() {
    return (
      <div>
        <QuestionLabel question={this.props.question} />
        <select
          value={this.props.answer}
          onChange={this.onChange}
          {...getControlProps(this.props.question, this.props.error)}
        >
          {this.props.question.SurveyQuestionChoices.map((choice: any) => {
            return (
              <option key={choice.ChoiceText} value={choice.ChoiceText}>
                {choice.ChoiceText}
              </option>
            );
          })}
        </select>
        <QuestionError
          questionId={this.props.question.QuestionID}
          error={this.props.error}
        />
      </div>
    );
  }
}

export default LanguageQuestion;
